import { SoundDto } from "./SoundDto";
import { SoundSourceMap } from "@pixi/sound";
import SOUND_CONFIG from "../audio/config/SoundConfig.json";

export class SoundData {
    private _soundsManifest: SoundSourceMap;
    public get soundsManifest(): SoundSourceMap {
        return this._soundsManifest;
    }
    public get soundParams(): SoundDto[] {
        return this._soundParams;
    }

    private constructor(private _soundParams: SoundDto[]) {
        this._soundsManifest = this.soundParams.reduce((prev, curr) => {
            if (curr !== null) {
                const [alias, path] = this.tryGetValues(curr);
                return { ...prev, [alias]: path };
            }
            return prev;
        }, {});
    }

    public static fromJson() {
        const soundParams = SOUND_CONFIG;
        return new SoundData(soundParams);
    }

    private tryGetValues({ alias, isMusic, volume, path }: SoundDto): [string, string] {
        if (alias != null && isMusic != null && volume != null && path != null) {
            return [alias, path];
        } else {
            throw new Error("SoundDataConfig: Some config value not valid!");
        }
    }
}